import React, {useEffect, useState} from "react";
import CardTable from "../../components/table/CardTable";
import columns from "./config/MachineTableConfig";
import IconButton from "../../components/button/IconButton";
import { useTranslation } from "react-i18next";

const ConfiguredMachineModelsTable = ({format, setLoader, reload, setSelectedMachineModel, readOnly}) => {

    const [machines, setMachines] = useState();
    const {t} = useTranslation();

    const actionsColumn = {
        field: "actions",
        label: t("common.actions"),
        sort: "desc",
        width: 53,
        type: "custom",
        custom: function (column, row, history, additionalInformation) {
            return <>
                {row.machineModelId ?
                    <IconButton variant="outline-primary"
                                size={"sm"}
                                className="btn-circle"
                                role="button"
                                icon={" fa-arrow-left "}
                                tooltip={t("common.details")}
                                onClick={() => {
                                    setSelectedMachineModel(format.machineModels.find(m => m.id === row.machineModelId))
                                }}
                    />
                    : ""
                }
            </>;
        }

    }

    function prepareMachineModels() {
        const result = format.machineTypes.map(type => {
            return {
                machineType: type,
                machinePresentableName: format.machineModels.find(m => m.machineType === type)?.presentableName,
                machineModelId: format.machineModels.find(m => m.machineType === type)?.id
            }
        })


        setMachines(result)
    }

    useEffect(() => {
        if (format) {
            prepareMachineModels()
        }
    }, [format])

    function getTitle() {
        const verified = format.machineModels.length
        const all = format.machineTypes.length


        return <>
            {t("common.machines")}

            {!readOnly &&
                <div className={"float-right"}>
                    <span className={"text-secondary font-weight-normal"}>{t("common.configured")}</span>
                    <span className={`badge badge-primary-outline mr-1 ml-1`}>
                     <span>{verified + "/" + all}</span>
                </span>
                </div>
            }

        </>;
    }

    return (
        <>
            {format &&


                <CardTable
                    tittle={getTitle()}
                    initData={machines}
                    columns={columns(t).concat([actionsColumn])}
                    width={12}
                    pagination={false}
                    withoutHeader={readOnly}
                    setLoader={setLoader}
                    reload={reload}
                    disableIfNotCkecked={true}
                    striped={false}
                    className={"mx-0 px-0"}
                    shadow={true}
                />
            }

        </>
    );
};


export default ConfiguredMachineModelsTable;